import { Box } from "@chakra-ui/layout";
import SelectBaseAntd, {
  SelectBaseAntdProps,
} from "components/Input/SelectBaseAntd";
import useParametrosCobrancaJuros from "core/features/condominio/hooks/useParametrosCobrancaJuros";
import { useCurrentTenant } from "features/auth/tenant.store";
import { useState } from "react";

export interface SelectParametrosJurosProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: T | undefined;
  onChange: (v: any, option?: any) => void;
  tenantId?: string;
}

function SelectParametrosJuros({
  value,
  onChange,
  isInvalid,
  tenantId,
  ...rest
}: SelectParametrosJurosProps) {
  const { tenant } = useCurrentTenant();
  const { isLoading, isFetching, data } = useParametrosCobrancaJuros(
    tenantId || tenant.id
  );

  const [search, setSearch] = useState<string>();

  const _isLoading = isLoading || isFetching;

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={_isLoading}
      size="large"
      placeholder="Selecione uma taxa de juros"
      style={{ width: "100%" }}
      value={value}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={(v) => {
        setSearch(v);
      }}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.valor,
        label: `${item.valor} %`,
      }))}
      notFoundContent={
        !_isLoading ? (
          <Box>Nenhum juros configurado</Box>
        ) : (
          <Box>Carregando...</Box>
        )
      }
    />
  );
}

export default SelectParametrosJuros;
